














































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { v4 } from 'uuid';
import { requiredRule, exactLengthRule } from '@/vue-app/utils/form-rules';
import Card from '../Card.vue';
import CustomAutocomplete from '@/vue-app/components/onboarding/CustomAutocomplete.vue';
import TYPES from '@/types';

// Application
import GetAddressQueryService
  from '@/modules/onboarding/address/application/queries/get-address-query-service';
import GetCountriesQueryService
  from '@/modules/onboarding/catalogs/country/application/queries/get-countries-query-service';
import { GetSuburbsInZipCodeQuery } from '@/modules/onboarding/catalogs/suburb/application/queries';
import SearchAgreementsQuery
  from '@/modules/agreements/application/queries/search-agreements-query';
import { GetOnboardingStepQuery } from '@/modules/onboarding/status/application/queries';

// Domain
import { CustomerAddressEntity }
  from '@/modules/onboarding/address/domain/entities/customer-address-entity';
import { CustomerAgreementEntity }
  from '@/modules/onboarding/status/domain/entities/customer-agreement-entity';
import { AgreementEntity } from '@/modules/agreements/domain/entities/agreement-entity';
import { CountryEntity }
  from '@/modules/onboarding/catalogs/country/domain/entities/country-entity';
import { StepEntity } from '@/modules/onboarding/status/domain/entities';
import { SuburbInZipCodeEntity } from '@/modules/onboarding/catalogs/suburb/domain/entities';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';
import DatetimeValue from '@/modules/shared/domain/value-objects/datetime-value';

@Component({
  name: 'AddressInfo',
  components: { Card, CustomAutocomplete },
})
export default class AddressInfo extends Vue {
  @Inject(TYPES.GET_ADDRESS_ONBOARDING_QUERY_SERVICE)
  readonly getAddressQueryService!: GetAddressQueryService;

  @Inject(TYPES.GET_COUNTRIES_QUERY_SERVICE)
  readonly get_countries_query!: GetCountriesQueryService;

  @Inject(TYPES.GET_SUBURBS_IN_ZIP_CODE_QUERY)
  readonly getSuburbsInZipCodeQuery!: GetSuburbsInZipCodeQuery;

  @Inject(TYPES.SEARCH_AGREEMENTS_QUERY)
  readonly search_agreements_query!: SearchAgreementsQuery;

  @Inject(TYPES.GET_ONBOARDING_STEP_QUERY)
  private readonly get_on_boarding_step_query!: GetOnboardingStepQuery;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  @Inject(TYPES.DATETIME_VALUE)
  datetimeValue!: DatetimeValue;

  mounted_info = false;

  current_step: StepEntity = {
    current_step: '',
    id: '',
    payload: {},
  };

  inputs: CustomerAddressEntity = {
    customer_address_proof_of_address_id: null,
    customer_address_id: '',
    customer_address_default: false,
    address: {
      id: '',
      street: '',
      external_number: '',
      interior_number: '',
      zip_code: '',
      settlement: '',
      municipality: '',
      state: '',
      city: '',
      address_type: 'personal',
      country: {
        id: '',
        name: '',
      },
      created_at: new Date().toUTCString(),
      updated_at: new Date().toUTCString(),
    },
  };

  user_agreement: CustomerAgreementEntity = {
    accepted_on: null,
    agreement_type_id: '',
    was_accepted: false,
    id: '',
    description: '',
  };

  form_validity = false;

  rules = {
    required: [requiredRule],
    zip_code: [requiredRule, (value: string) => exactLengthRule(5, value)],
  };

  confirm_data = false;

  agreements: Array<AgreementEntity> = []

  suburbs_in_zip_code: Array<SuburbInZipCodeEntity> = []

  countries: Array<CountryEntity> = []

  input_city_is_disabled = false;

  async loadCountries() {
    try {
      this.countries = await this.get_countries_query.execute();
    } catch {
      this.message_notifier.showErrorNotification('Ocurrió un error al cargar los países');
    }
  }

  async loadsSuburbsInZipCode(is_new_zip_code: boolean) {
    try {
      if (this.inputs.address.zip_code.length === 5) {
        this.suburbs_in_zip_code = await this.getSuburbsInZipCodeQuery
          .execute(this.inputs.address.zip_code);

        if (is_new_zip_code && this.suburbs_in_zip_code.length) {
          this.inputs.address.municipality = this.suburbs_in_zip_code[0].municipality_name;
          this.inputs.address.state = this.suburbs_in_zip_code[0].state_name;
          this.inputs.address.city = this.suburbs_in_zip_code[0].city_name;
          this.inputs.address.settlement = '';
          this.input_city_is_disabled = !!this.inputs.address.city;
        } else if (is_new_zip_code && !this.suburbs_in_zip_code.length) {
          this.inputs.address.municipality = '';
          this.inputs.address.state = '';
          this.inputs.address.settlement = '';
          this.inputs.address.city = '';
          this.input_city_is_disabled = false;
        }
      }
    } catch {
      this.message_notifier.showErrorNotification('Ocurrió un error al cargar las colonias');
    }
  }

  get addresses() {
    return this.current_step.payload.addresses;
  }

  get customer_addresses() {
    return this.getAddressQueryService.internalExecute();
  }

  @Watch('agreements')
  setAgreementData(new_agreements: Array<AgreementEntity>) {
    const agreement = new_agreements.find(
      (item) => item.name === 'address_confirmation',
    );

    if (agreement && this.current_step.payload.agreements) {
      const user_agreement = this.current_step.payload.agreements.find(
        (item: CustomerAgreementEntity) => item.agreement_type_id === agreement.id,
      );

      if (user_agreement) {
        this.user_agreement = user_agreement;
      } else {
        this.user_agreement = {
          ...this.user_agreement,
          id: v4(),
          description: agreement.description,
          agreement_type_id: agreement.id,
        };
      }
    }
  }

  setDefaultCountry() {
    if (!this.inputs.address.country.id) {
      const default_country = this.countries.find((country) => country.value === 'México');

      if (default_country) {
        this.inputs.address.country = {
          id: default_country.id,
          name: default_country.value,
        };
      }
    }
  }

  @Watch('confirm_data')
  handleConfirmData(new_confirm_data: boolean) {
    if (new_confirm_data && this.mounted_info) {
      this.user_agreement = {
        ...this.user_agreement,
        was_accepted: true,
        accepted_on: this.datetimeValue.create(),
      };
    }
  }

  @Watch('customer_addresses')
  async setAddress() {
    const address = this.addresses.find(
      (item: CustomerAddressEntity) => item.address.address_type === 'personal',
    );

    if (address) {
      this.inputs = address;
      await this.loadsSuburbsInZipCode(false);
      this.input_city_is_disabled = true;
    } else {
      const customer_address = this.customer_addresses.find(
        (item) => item.address.address_type === 'personal',
      );
      if (customer_address) {
        this.inputs = customer_address;
        await this.loadsSuburbsInZipCode(true);
      } else {
        const id = v4();
        this.inputs.customer_address_id = id;
        this.inputs.customer_address_default = true;
        this.inputs.address.id = id;
      }
    }
  }

  async loadAgreements() {
    this.agreements = await this.search_agreements_query.execute();
  }

  async created() {
    this.current_step = await this.get_on_boarding_step_query.execute('personal_information');
    await this.loadAgreements();
    await this.loadCountries();
    this.setAgreementData(this.agreements);
    await this.setAddress();
    this.setDefaultCountry();
    this.confirm_data = this.current_step.payload.confirm_data.address;

    setTimeout(() => {
      this.mounted_info = true;
    }, 1000);
  }
}
